package one.healthium.data.user.utils

import dev.gitlive.firebase.firestore.Timestamp
import kotlin.time.Instant

fun Timestamp.toInstant(): Instant {
    return Instant.fromEpochSeconds(seconds, nanoseconds)
}

fun Timestamp.toId() = toInstant().toString()